import 'whatwg-fetch'
// import Flickity from 'flickity'
// import 'flickity-imagesloaded'
// import 'flickity-fade'

import './components/fixes'
import { autoAlways, Modal } from 'jesuits-eum-framework/src/assets/js/main'
import MainHeader from './components/MainHeader'

import newsSelector from './components/newsSelector'
import donationBox from './components/donationBox'

autoAlways()

const mainHeader = new MainHeader(document.querySelector('.custom-main-header'))
mainHeader.init()

Array.from(document.querySelectorAll('.carousel__slider')).forEach(
  (el) =>
    new Flickity(el, {
      cellAlign: 'left',
      wrapAround: true,
      imagesLoaded: true,
      autoPlay: el.getAttribute('data-autoplay'),
    }),
)

if (document.querySelector('.js-news-selector')) newsSelector()

const modalManager = new Modal()
const modal = document.getElementById('donation-box')

// Pulsanti specifici dei progetti che aggiungono la query string
const projectDonationButtons = document.querySelectorAll(
  '.project-donation__button.btn.donation-modal',
)
projectDonationButtons.forEach((el) =>
  el.addEventListener('click', (e) => {
    e.preventDefault()
    modalManager.open(modal)
    const url = new URL(window.location)
    url.searchParams.set('openModal', 'donation-box')
    window.history.pushState({}, '', url)
  }),
)

// Altri pulsanti donation-modal che non aggiungono la query string
const otherDonationButtons = document.querySelectorAll(
  '.donation-modal:not(.project-donation__button)',
)
otherDonationButtons.forEach((el) =>
  el.addEventListener('click', (e) => {
    e.preventDefault()
    modalManager.open(modal)
  }),
)

const searchModal = document.getElementById('search-modal')
const searchInput = document.querySelector('[name=s]')

console.log('called')

document.querySelector('.js-search-trigger').addEventListener('click', (e) => {
  e.preventDefault()
  modalManager.open(searchModal)
  console.log(searchInput)
  searchInput.focus()
})

donationBox()

// slider home
Array.from(document.querySelectorAll('.intro__image')).forEach(
  (el) =>
    new Flickity(el, {
      cellAlign: 'left',
      // wrapAround: true,
      imagesLoaded: true,
      lazyLoad: 2,
      // pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      pageDots: false,
      fade: true,
      // autoPlay: el.getAttribute('data-autoplay'),
      autoPlay: 6000,
    }),
)

// Funzione per aprire la modale se la query string è presente
function checkAndOpenModal() {
  const urlParams = new URLSearchParams(window.location.search)
  const modalToOpen = urlParams.get('openModal')

  if (modalToOpen === 'donation-box') {
    modalManager.open(modal)
  }
}

// Chiamare la funzione all'onload
document.addEventListener('DOMContentLoaded', () => {
  checkAndOpenModal()
})
